import module from 'empresa/module.js'

export const schema = {
  fisica: 'boolean',
  regimen_fiscal_id: 'number',
  moral: 'boolean',
}

export default class EmpresasCatalogoRegimenFiscalService {
  constructor ($http) {
    this.$http = $http
  }

  get () {
    return this.$http.get('/api/empresas/catalogo/regimen_fiscal', {
      schema,
    })
  }
}

module.service('EmpresasCatalogoRegimenFiscal', EmpresasCatalogoRegimenFiscalService)



// WEBPACK FOOTER //
// ./src/empresas/services/Catalogo/RegimenFiscal.js